export const GET_ASSETS = 'document/get/GET_ASSETS';
export const SET_ASSETS = 'document/set/SET_ASSETS';

export const GET_JURIDICAL_CERT = 'document/get/GET_JURIDICAL_CERT';
export const SET_JURIDICAL_CERT = 'document/set/SET_JURIDICAL_CERT';